// extracted by mini-css-extract-plugin
export default {"questionsContainer":"questionsContainer-reh08","body":"body-qWkEK","footer":"footer-VK0pq"};